// extracted by mini-css-extract-plugin
module.exports = {"root":"Spider_root__17KFn"};